import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  spaceXLarge,
  breakpoints,
}: Theme) => ({
  root: {
    padding: `${spaceXLarge} 0`,
    background: palette.primary.dark,
    '& .slick-slide > div': {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      [breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem',
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    [breakpoints.up('lg')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
  listItem: {
    color: palette.primary.light,
  },
  link: {
    display: 'flex',
    textDecoration: 'none',
  },
}));
